import React, { useEffect, useState } from 'react';

// routes
import { useNavigate } from 'react-router-dom';

// components
import { Navbar } from 'react-bootstrap';

// icon
import { GoSignOut } from 'react-icons/go';

// assets
import defaultProfile from '../../assets/images/default_profile.jpeg';
import alcoholLogo from '../../assets/images/alcohol-logo.png';
import hearoLogo from '../../assets/images/hearro-logo.png';
import slideSidebarIcon from '../../assets/icons/icon-sidebar-temp.png';

// api
import {
	getUserProfileImageFromAlcohol,
	getUserInfoFromAlcohol,
} from '../../services/apis/alcohol/user';
import {
	getUserProfileImageFromHearro,
	getUserInfoFromHearro,
} from '../../services/apis/hearro/user';

function DashboardNavbar({ type, slideSidebar }) {
	const [displayName, setDisplayName] = useState('');

	const [profileImg, setProfileImg] = useState('');

	const navigate = useNavigate();

	const signOut = () => {
		localStorage.removeItem(`${type}token`);
		localStorage.removeItem('saveId');
		sessionStorage.removeItem('hasShownLoginToast');
		navigate(`/sign-in/${type}`);
	};

	async function getUserProfileImageFromAPI() {
		try {
			const res =
				type === 'dtx001'
					? await getUserProfileImageFromAlcohol()
					: await getUserProfileImageFromHearro();
			if (parseInt(res.status / 200, 10) === 1) {
				const imgURL = URL.createObjectURL(res.data);
				setProfileImg(imgURL || '');
			} else {
				throw new Error();
			}
		} catch (err) {
			console.error(err);
			setProfileImg('');
		}
	}

	useEffect(() => {
		const tokenInfo = JSON.parse(localStorage.getItem(`${type}token`));
		if (!tokenInfo) {
			signOut();
			return;
		}

		if (tokenInfo.displayName) {
			setDisplayName(tokenInfo.displayName);
		}

		// dtx001/dtx002는 API의 name을 항상 우선 반영해 동기화
		let syncName = null;
		if (type === 'dtx001') {
			syncName = getUserInfoFromAlcohol;
		} else if (type === 'dtx002') {
			syncName = getUserInfoFromHearro;
		}
		if (syncName) {
			syncName()
				.then(res => {
					if (parseInt(res.status / 200, 10) === 1 && res.data?.name) {
						setDisplayName(res.data.name);
						localStorage.setItem(
							`${type}token`,
							JSON.stringify({ ...tokenInfo, displayName: res.data.name }),
						);
					}
				})
				.catch(() => {
					// 무시: 실패 시 기존 토큰의 displayName 사용
				});
		}

		getUserProfileImageFromAPI();
	}, []);

	return (
		<Navbar className="dashboardNavbar headerWrapper">
			<div className="dashboardNavbar__brand">
				<Navbar.Brand>
					<img
						src={type === 'dtx001' ? alcoholLogo : hearoLogo}
						className="dashboardNavbar__brand__logo"
						alt="home"
						role="none"
						onClick={() => window.location.replace(`/${type}`)}
						style={{ width: type === 'dtx001' ? '7.5rem' : '10rem' }}
					/>
				</Navbar.Brand>
				<button className="dashboardNavbar__slide_btn" onClick={slideSidebar}>
					<img src={slideSidebarIcon} alt="slide sidebar" />
				</button>
			</div>
			<div className="dashboardNavbar__menu">
				<img
					className="dashboardNavbar__menu__profile"
					src={profileImg || defaultProfile}
					alt="profile"
				/>
				<span className="dashboardNavbar__menu__username">{displayName}</span>
				<GoSignOut className="dashboardNavbar__menu__signout" onClick={signOut} />
			</div>
		</Navbar>
	);
}

export default DashboardNavbar;
